"use client"

import { useAppDispatch } from "@/hooks/redux"
import { productActions } from "@/lib/redux/features/product/reduce"
import { Col, Row } from "antd"
import { useParams } from "next/navigation"
import ProductItem from "./ProductItem"
import { TypeProduct } from "@/lib/redux/features/product/type"
import { TypeCategory, TypeStoreDetail } from "@/lib/redux/features/store/type"
import _ from "lodash"
import CategoryProductsItemLoadMore from "../../Home/Categories/CategoryProductsItemLoadMore"

let refSSR: any = {}

const CategoryProducts = ({ store, ...props }: {
  categoryDetail: TypeCategory & { url: string, baseUrl: string },
  categoryProductsResponse: any,
  store: TypeStoreDetail
}) => {
  const dispatch = useAppDispatch()
  const params = useParams()
  if (!refSSR[`${params.type}_${params.categoryId}`]) {
    refSSR = {
      [`${params.type}_${params.categoryId}`]: true
    }
    dispatch(productActions.setCategoryProductsData(props.categoryProductsResponse))
  }

  const products = props.categoryProductsResponse?.results || []

  return (
    <Row justify="center" className="page">
      <Col className="page__section">
        <CategoryProductsItemLoadMore
          page={props.categoryProductsResponse.page}
          pageSize={props.categoryProductsResponse.page_size}
          total={props.categoryProductsResponse.total_length}
        >
          <Row style={{ rowGap: 15, marginInline: '-0.75rem' }} className="product__list">
            {products.map((product: TypeProduct) => {
              return (
                <ProductItem store={store} customGridProduct={store.grid_products} product={product} key={product.id} />
              )
            })}
          </Row>
        </CategoryProductsItemLoadMore>
      </Col>
    </Row>
  )
}

export default CategoryProducts